export const metaInfo = {
    name:"cometchat-chat-sample-app-react",
    version:"4.2.0",
    type:"sample",
    platform:"React"
}